import * as React from 'react'
import {updateModuleInstance} from '../../BackendFacade/apiCalls'
import {IAllModules_Edit, Popup} from '../../Interfaces/IAllModules_Edit'
import {IModule} from '../../../../BackendFacade/IModuleInstances'
import {useMain} from '../../../../Utils/SessionControls/mainContext'
import OdxModal from '../../../../OdxComponents/NativeOdx/Modal/Odx-Modal'
import {moduleIcons} from '../../Icons/Icons'
import OdxInputField from '../../../../OdxComponents/NativeOdx/FormControls/Odx-InputField'
import {NetworkData} from "../../../../BackendFacade";
import {simplifyForHtmlId} from "../../../../Utils/transformer";

interface IProps {
    onSuccessFunction?: (response: NetworkData) => Promise<void>,
    closeFunction?: () => void,
    state: IModule,
    projectId: string,
    isOpen: boolean,
    moduleDescription?: string
}

const EditModule: React.FC<IProps> = ({
                                               onSuccessFunction,
                                               closeFunction,
                                               state,
                                               projectId,
                                               isOpen,
                                               moduleDescription
                                           }) => {
    const [moduleInstanceId, setModuleInstanceId] = React.useState(state.moduleInstanceId)
    const [staticModuleId, setStaticModuleId] = React.useState(state.staticModuleId)
    const [group, setGroup] = React.useState(state.group)
    const [linkedId, setLinkedId] = React.useState(state.linkedId)
    const [displayName, setDisplayName] = React.useState(state.displayName)
    const [creationProps, setCreationProps] = React.useState(state.creationProps)
	    const [popup, setPopup] = React.useState<Popup>(Popup.None)
	    const baseId = `project-edit-module-${simplifyForHtmlId(moduleInstanceId)}`;

    const {setLoading, createErrorToast} = useMain();

    /**
     * Applies the changes to the project
     */
    const applyProject = () => {
        setLoading(true);
        const state = {
            moduleInstanceId: moduleInstanceId,
            staticModuleId: staticModuleId,
            group: group,
            linkedId: linkedId,
            displayName: displayName,
            creationProps: creationProps,
        } as IAllModules_Edit;
        updateModuleInstance(projectId, state).then((data) => {
            setLoading(false);
            if (data.success) {
                onSuccessFunction(data); // Notify the parent component
                closeFunction(); // Close the modal
            } else {
                createErrorToast(data.message);
            }
        });
    };

    const mainContent = () => {

	        return <div id={`${baseId}-view`}>
	            <OdxModal size={"small"} title={"Edit module"}
	                      onClose={closeFunction} footerButtons={[
                <odx-button
                    key="dismiss"
                    id={`OdxButton_${baseId}-dismiss-btn`}
                    variant="ghost"
                    size="lg"
                    type="button"
                    onClick={() => {
                        closeFunction()
                    }}
                >
	                    Dismiss
	                </odx-button>,
	                <odx-button
	                    key="save"
	                    id={`OdxButton_${baseId}-save-btn`}
	                    variant="primary"
	                    size="lg"
	                    type="button"
	                    onClick={() => {
	                        applyProject()
	                    }}
                >
                    Save
                </odx-button>
	            ]}
	            isOpen={isOpen}
	            variant={"sidesheet"}
	            imgSrcInHeader={moduleIcons[staticModuleId] ? moduleIcons[staticModuleId] : moduleIcons["default"]}
	            id={baseId}
	            >
	                <div data-odxLayout={"flex"} className={""} id={`${baseId}-summary`}>
	                    <div>
	                        <div className={"!text-4xl font-semibold !pt-3.5 !pb-3.5"} id={`${baseId}-title`}>{state.displayName}</div>
	                        <div className={"!text-2xl"} id={`${baseId}-description`}>{moduleDescription}</div>
	                    </div>
	                </div>
	                <hr/>
	                <div className={"!pt-6"} id={`${baseId}-form`}>
	                    <OdxInputField isRequired={true} id={`${baseId}-display-name`} label={"Displayname"} value={displayName}
	                                   onChange={(event) => setDisplayName(event.target.value)}/>
	                    <OdxInputField isRequired={true} id={`${baseId}-group`} label={"Group"} value={group}
	                                   onChange={(event) => setGroup(event.target.value)}/>
	                </div>
	            </OdxModal>
	        </div>
    }

    return <div>
        {mainContent()}
    </div>;

}

export default EditModule;
